import { QueryClient } from "@tanstack/react-query";
import { createRouter, Link, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { routeTree } from "./routeTree.gen";
import {
  installStaleModuleRecovery,
  isStaleModuleError,
  reloadOnceForStaleModules,
} from "./lib/stale-module-recovery";

export const getRouter = () => {
  const queryClient = new QueryClient();

  installStaleModuleRecovery();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    defaultErrorComponent: ({ error, reset }) => {
      const router = useRouter();
      const msg = error?.message || "";
      const isChunkError = isStaleModuleError(msg);
      useEffect(() => {
        if (!isChunkError) return;
        reloadOnceForStaleModules();
      }, [isChunkError]);

      return (
        <div className="flex min-h-screen items-center justify-center bg-background px-4 grid-bg">
          <div className="glass max-w-md text-center p-8 rounded-xl">
            <p className="font-mono text-xs text-amber tracking-[0.3em]">SYSTEM_FAULT</p>
            <h1 className="mt-3 font-display text-2xl">{isChunkError ? "Updating console…" : "Route pipeline interrupted"}</h1>
            <p className="mt-2 text-sm text-muted-foreground">{isChunkError ? "A new build is available. Reloading…" : msg}</p>
            <div className="mt-6 flex justify-center gap-2">
              <button
                onClick={() => {
                  if (isChunkError && typeof window !== "undefined") { window.location.reload(); return; }
                  router.invalidate(); reset();
                }}
                className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
              >
                {isChunkError ? "Reload now" : "Retry"}
              </button>
              <a href="/dashboard" className="rounded-md border border-panel-border bg-panel/40 px-4 py-2 text-sm">Command</a>
            </div>
          </div>
        </div>
      );
    },
  });

  return router;
};
